export default "dist/images/block-button-spread.01dcafd.png";